import gql from 'graphql-tag'

export const GET_VEHICLE = gql`
query Vehicles($filter: GetVehiclesFilter) {
  vehicles(filter: $filter) {
    isSuccessful
    message
    vehicles {
      id
      door1
      door2
      companyId
      ownership
      company {
        id
        name
        logoUrl
        idleTimeout
        parkTimeout
        offlineTimeout
        fuelGainAlert
        fuelLossAlert
        isActive
      }
      driver1Id
      driver2Id
      driver1 {
        fullname
      }
      driver2 {
        fullname
      }
      garageId
      garage {
        geofenceId
        companyId
        fenceName
        type
        polyData
        circData
        address
        addressDetail
        province
        city
        postalCode
        category
        contactName
        phoneNo
        isGarage
        isServiceLoc
        serviceLocType
      }
      tonnage
      volume
      fuelEfficiency
      fuelCapacity
      odometer
      status
      imei
      device {
        imei
        identifier
        companyId
        vehicleId
        phoneNo
        ip
        port
        deviceCode
        deviceName
        vendorType
        portKernel
        activeOn
        status
        domain
        database
        username
        password
      }
      licensePlate
      hullNo
      vehicleTypeId
      vehicleType {
        vehicleTypeId
        companyId
        isActive
        manufacturer
        model
        type
        category
        transmissionType
        fuelType
        tonnage
        volume
      }
      thermoType
      boxType
      chassisNumber
      machineNumber
      carrosserie
      year
      vehicleDocs {
        licensePlate
        vehicleId
        docType
        docNumber
        validUntil
      }
      ownership
    }
  }
}
`

export const GET_VEHICLE_ID = gql`
query Vehicle($filter: GetVehicleFilter!) {
  vehicle(filter: $filter) {
    isSuccessful
    message
    vehicle {
      year
      licensePlate
      hullNo
      imei
      ownership
      vehicleDocs {
        docType
        docNumber
        validUntil
      }
      odometer
      machineNumber
      garage {
        fenceName
        geofenceId
      }
      chassisNumber
      carrosserie
      driver1 {
        userId
        isDriver
        fullname
      }
      driver2 {
        userId
        isDriver
        fullname
      }
      status
      thermoType
      boxType
      device {
        imei
        identifier
        vendorType
        deviceName
        phoneNo
      }
      fuelEfficiency
      vehicleType {
        vehicleTypeId
        companyId
        isActive
        manufacturer
        model
        type
        category
        transmissionType
        fuelType
        tonnage
        volume
        hasRelation
      }
    }
  }
}
`
export const GET_VEHICLE_AUDIT_LOG = gql`
query VehicleAuditLogs($filter: VehicleAuditLogInput!) {
  vehicleAuditLogs(filter: $filter) {
    vehicleAuditLogs {
      time
      title
      action
      detail
      user
    }
    isSuccessful
    message
  }
}
`

export const VEHICLE_MUTATION_CREATE = gql`
mutation CreateVehicle($input: CreateVehicleInput!) {
  createVehicle(input: $input) {
    isSuccessful
    message
    vehicle {
      id
    }
  }
}
`

export const VEHICLE_MUTATION_UPDATE = gql`
mutation UpdateVehicle($input: UpdateVehicleInput!) {
  updateVehicle(input: $input) {
    isSuccessful
    message
    vehicle {
      id
    }
  }
}
`
